import ReactMarkdown from "react-markdown";
import { cn } from "../../lib/utils";

export function PromptMarkdown({
  content,
  ariaLabel,
  className,
  emptyMessage = "No prompt content has been added yet.",
  id,
}: {
  content: string;
  ariaLabel: string;
  className?: string;
  emptyMessage?: string;
  id?: string;
}) {
  return (
    <div
      id={id}
      aria-label={ariaLabel}
      className={cn(
        "w-full overflow-auto rounded-lg border border-line bg-canvas px-6 py-5 text-sm leading-7 text-ink",
        "[&_h1]:mb-4 [&_h1]:mt-1 [&_h1]:text-xl [&_h1]:font-bold [&_h1]:leading-8",
        "[&_h2]:mb-3 [&_h2]:mt-7 [&_h2]:border-b [&_h2]:border-line [&_h2]:pb-2 [&_h2]:text-lg [&_h2]:font-bold",
        "[&_h3]:mb-2 [&_h3]:mt-6 [&_h3]:text-base [&_h3]:font-bold",
        "[&_h4]:mb-2 [&_h4]:mt-5 [&_h4]:text-sm [&_h4]:font-bold",
        "[&_p]:my-3 [&_p]:whitespace-pre-wrap [&_strong]:font-bold",
        "[&_ul]:my-3 [&_ul]:list-disc [&_ul]:space-y-1.5 [&_ul]:pl-6",
        "[&_ol]:my-3 [&_ol]:list-decimal [&_ol]:space-y-1.5 [&_ol]:pl-6 [&_li]:pl-1",
        "[&_blockquote]:my-4 [&_blockquote]:border-l-4 [&_blockquote]:border-brand/40 [&_blockquote]:bg-brand-soft/40 [&_blockquote]:px-4 [&_blockquote]:py-2",
        "[&_code]:rounded [&_code]:bg-soft [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-[12px]",
        "[&_pre]:my-4 [&_pre]:overflow-x-auto [&_pre]:rounded-lg [&_pre]:border [&_pre]:border-line [&_pre]:bg-soft [&_pre]:p-4",
        "[&_pre_code]:bg-transparent [&_pre_code]:p-0 [&_hr]:my-6 [&_hr]:border-line [&_a]:font-semibold [&_a]:text-brand [&_a]:underline",
        className,
      )}
    >
      {content.trim() ? (
        <ReactMarkdown>{content}</ReactMarkdown>
      ) : (
        <div className="flex min-h-[240px] items-center justify-center text-center text-xs text-ink-3">
          {emptyMessage}
        </div>
      )}
    </div>
  );
}
